import { makeStyles } from 'tss-react/mui'

import { hubloTheme } from '@front/theme'

export const useAppButtonStyles = makeStyles()(() => ({
  button: {
    fontFamily: 'Figtree, sans-serif',
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '24px',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 8,
    padding: hubloTheme.spacing(0, 1.5),
    boxShadow: 'none',
    textAlign: 'center',
    textTransform: 'none',
    '&.Mui-disabled': {
      backgroundColor: hubloTheme.palette.common.grey0,
      borderColor: hubloTheme.palette.common.grey0,
      color: hubloTheme.palette.common.grey15,
    },

    '&:hover': {
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
    },
    '&:focus-visible': {
      boxShadow: 'none',
      outline: `solid 2px ${hubloTheme.palette.common.black20}`,
      outlineOffset: '2px',
    },
  },

  loader: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
  },

  size_default: {
    height: 48,
  },
  size_small: {
    height: 40,
  },

  primary: {
    color: hubloTheme.palette.common.white,
    backgroundColor: hubloTheme.palette.common.blue15,
    // make contained buttons same size as outlined buttons (which have borders)
    borderColor: hubloTheme.palette.common.blue15,
  },

  '@media (hover: hover)': {
    primary: {
      '&:hover': {
        backgroundColor: hubloTheme.palette.common.blue10,
        borderColor: hubloTheme.palette.common.blue10,
      },
    },
  },

  secondary: {
    color: hubloTheme.palette.common.blue15,
    borderColor: hubloTheme.palette.common.blue15,
    '&:hover': {
      backgroundColor: hubloTheme.palette.common.blue0,
    },
  },

  secondaryDarkBg: {
    color: hubloTheme.palette.common.white,
    borderColor: hubloTheme.palette.common.white,

    '&:hover': {
      backgroundColor: hubloTheme.palette.common.blue15,
    },

    '&:focus-visible': {
      outline: `solid 2px ${hubloTheme.palette.common.white}`,
      outlineOffset: '2px',
    },
  },

  delete: {
    color: hubloTheme.palette.common.white,
    backgroundColor: hubloTheme.palette.common.red15,
    borderColor: hubloTheme.palette.common.red15,

    '&:hover': {
      backgroundColor: hubloTheme.palette.common.red10,
      borderColor: hubloTheme.palette.common.red10,
    },
  },

  deleteInverted: {
    color: hubloTheme.palette.common.red15,
    backgroundColor: hubloTheme.palette.common.white,
    borderColor: hubloTheme.palette.common.white,

    '&:hover': {
      backgroundColor: hubloTheme.palette.common.white,
      borderColor: hubloTheme.palette.common.red10,
    },
  },

  containedDisabled: {
    '&:disabled': {
      backgroundColor: hubloTheme.palette.common.grey0,
      borderColor: hubloTheme.palette.common.grey0,
      color: hubloTheme.palette.common.grey15,
    },
  },
  secondaryDisabled: {
    '&:disabled': {
      borderColor: hubloTheme.palette.common.grey15,
      color: hubloTheme.palette.common.grey15,
    },
  },
  secondaryDarkBgDisabled: {
    '&:disabled': {
      borderColor: hubloTheme.palette.common.grey10,
      color: hubloTheme.palette.common.grey10,
    },
  },

  disableEvents: {
    pointerEvents: 'none',
  },

  transparent: {
    opacity: 0,
  },
}))
